// removed by extract-text-webpack-plugin
module.exports = {"form":"form__form___2Mt5o base__formItem___3m4S4","formFocus":"form__formFocus___ymOxF base__formItemFocus___2Pzi- base__formItem___3m4S4","input":"form__input___3RRfH base__input___1wYLZ","submit":"form__submit___1fmRR base__submit___3XXRO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsletterForm/form.css
// module id = 298
// module chunks = 1